// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ModalPayment_wrapper__2P4dm"};